import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import globalSettingsStores from '../../../../../stores/settings-stores';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const deleteScholarshipFunderOperation = async (
  funderId: number,
  setFunderId: (funderId: number | null) => void,
) => {
  try {
    setFunderId(funderId);

    const res = await appApi.deleteScholarshipFunder(funderId);
    if (res.data.ok) {
      await globalSettingsStores.fetchSetting();
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    }
    setFunderId(null);
  } catch (e) {
    setFunderId(null);
    console.error(
      `deleteScholarshipFunderOperation failed with the funderId: ${funderId}, and the error: ${e}`,
    );
    toast.error(`משהו קרה, נסה שוב בעוד מספר רגעים...`);
  }
};
